"use strict";

exports.__esModule = true;
exports.GroupedBarChart = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Bar = require("./Bar");
var _excluded = ["width", "height", "series", "xScale", "yScale", "barWidth", "padding"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Displays bar chart series.
 */

var GroupedBarChart = exports.GroupedBarChart = function GroupedBarChart(props) {
  var width = props.width,
    height = props.height,
    series = props.series,
    xScale = props.xScale,
    yScale = props.yScale,
    barWidth = props.barWidth,
    padding = props.padding,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var getXValue = series.getXValue,
    getYValue = series.getYValue,
    data = series.data;
  var barKeyState = {};
  var bars = [];
  var topX = function topX(item) {
    var positionKey = barKeyState && barKeyState[item.key] || 0;
    barKeyState[item.key] = positionKey + 1;
    var paddingLeft = padding;
    if (positionKey === 0) {
      paddingLeft = 0;
    }
    return xScale(getXValue(item)) + (barWidth + paddingLeft) * positionKey;
  };
  /*
   if -- >
      NORMAL BAR ->
      data = {
        key: "Day-1",
        value: "24"
      }
  else -->
    STACKED BAR ->
      data = {
        key: "Day-1",
        value: {
          [ key: "A", value: 40 ]
          [ key: "A", value: 60 ]
        }
      }
   ALSO -->
   |
  |
  |           MajorBar
  |          ____|____
  |
  |         |         |         |         |
  |____|____|____|____|____|____|____|____|
    |
  MinorBar
    */

  data.forEach(function (item) {
    var majorBarValue = getYValue && getYValue(item) || item.value;
    var majorBarKey = getXValue && getXValue(item) || item.key || "";
    var majorBar = /*#__PURE__*/_react["default"].createElement("g", {
      key: majorBarKey,
      className: "majorBar",
      "data-key": majorBarKey
    }, majorBarValue.map(function (minorBar) {
      var RenderBar = minorBar.render || _Bar.Bar;
      var value = item.getYValue && item.getYValue(minorBar) || minorBar.value;
      var key = item.getXValue && item.getXValue(minorBar) || minorBar.key || "";
      var bar = /*#__PURE__*/_react["default"].createElement(RenderBar, {
        x: topX(item),
        height: height,
        color: minorBar.color,
        yScale: yScale,
        barWidth: barWidth,
        value: value
      });
      if (item.getTooltip !== undefined) {
        // As in BarChart: the popover target must be an SVG element, not
        // Blueprint's default <span>, or the bars are never painted.
        return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
          key: key,
          targetTagName: "g",
          modifiers: {
            preventOverflow: {
              enabled: false
            },
            hide: {
              enabled: false
            }
          },
          position: _core.Position.RIGHT,
          interactionKind: _core.PopoverInteractionKind.HOVER,
          content: item.getTooltip(minorBar)
        }, /*#__PURE__*/_react["default"].createElement("g", {
          key: key,
          "data-key": key,
          className: "bar"
        }, bar));
      } else {
        return /*#__PURE__*/_react["default"].createElement("g", {
          key: key,
          "data-key": key,
          className: "bar"
        }, bar);
      }
    }));
    bars.push(majorBar);
  });
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "data-testid": "grouped-bar-chart",
    width: width,
    height: height
  }, extra), bars);
};